var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaymentCancelled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3969_10439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 0C11.2598 0 0 11.2598 0 25C0 38.7402 11.2598 50 25 50C38.7402 50 50 38.7402 50 25C50 11.2598 38.7402 0 25 0ZM5.95703 25C5.95703 14.5116 14.5116 5.95703 25 5.95703C28.955 5.95703 32.7638 7.1874 36.0156 9.50186L25 20.5175L9.50205 36.0156C7.1874 32.7636 5.95703 28.955 5.95703 25ZM25 44.043C21.045 44.043 17.2362 42.8124 13.9844 40.498L40.498 13.9843C42.8126 17.2362 44.043 21.0448 44.043 25C44.043 35.4882 35.4884 44.043 25 44.043Z",
    fill: "#FF3636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 25C50 38.7402 38.7402 50 25 50V44.043C35.4884 44.043 44.043 35.4882 44.043 25C44.043 21.0448 42.8126 17.2362 40.4979 13.9844L25 29.4823V20.5175L36.0156 9.50186C32.7638 7.1874 28.955 5.95703 25 5.95703V0C38.7402 0 50 11.2598 50 25Z",
    fill: "#FF3636"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3969_10439"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentCancelled);
export default __webpack_public_path__ + "static/media/paymentCancelled.efc653185ddcda08281b31042446f010.svg";
export { ForwardRef as ReactComponent };